import React from "react";
var __jsx = React.createElement;
/**
 * Case block for Switch component
 */
export var Case = function Case(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};